// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { CancelAppointmentData, CancelAppointmentPostData, CancelAppointmentPostResponses, CancelAppointmentPostWithoutsiteIdData, CancelAppointmentPostWithoutsiteIdResponses, CancelAppointmentResponses, CancelAppointmentWithoutSiteIdData, CancelAppointmentWithoutSiteIdResponses, CancelTechnicianOnWayToSiteData, CancelTechnicianOnWayToSiteResponses, ConfirmAppointmentData, ConfirmAppointmentResponses, CountFlexAppointmentAndCountAppointmentCloseDeadLineData, CountFlexAppointmentAndCountAppointmentCloseDeadLineResponses, CreateFlexibleAppointmentData, CreateFlexibleAppointmentResponses, CreateForcedPartnerAppointmentData, CreateForcedPartnerAppointmentResponses, CreateLinkBetweenTwoEventsData, CreateLinkBetweenTwoEventsErrors, CreateLinkBetweenTwoEventsResponses, CreatePartnerAppointmentData, CreatePartnerAppointmentResponses, CreateSiteAppointmentPreparationData, CreateSiteAppointmentPreparationResponses, CreateSiteV2Data, CreateSiteV2Errors, CreateSiteV2Responses, DeclareTechnicianOnWayToSiteData, DeclareTechnicianOnWayToSiteResponses, DeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureData, DeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureErrors, DeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponses, DeleteThirdPartySensorApplianceAssociationData, DeleteThirdPartySensorApplianceAssociationErrors, DeleteThirdPartySensorApplianceAssociationResponses, DownloadPhotoData, DownloadPhotoResponses, GetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailData, GetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailErrors, GetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailResponses, GetApiGatewayShipmentModelTypesData, GetApiGatewayShipmentModelTypesErrors, GetApiGatewayShipmentModelTypesResponses, GetApiGatewayShipmentReasonsData, GetApiGatewayShipmentReasonsErrors, GetApiGatewayShipmentReasonsResponses, GetApiMomboxSerialBySerialSearchData, GetApiMomboxSerialBySerialSearchErrors, GetApiMomboxSerialBySerialSearchResponses, GetApiPhoningEndCallReasonsData, GetApiPhoningEndCallReasonsErrors, GetApiPhoningEndCallReasonsResponses, GetApiReferenceSupportSubscriberNeedsData, GetApiReferenceSupportSubscriberNeedsErrors, GetApiReferenceSupportSubscriberNeedsResponses, GetApiReferenceTypeSupportData, GetApiReferenceTypeSupportErrors, GetApiReferenceTypeSupportResponses, GetApiSiteBySiteIdGatewayShipmentHistoryData, GetApiSiteBySiteIdGatewayShipmentHistoryErrors, GetApiSiteBySiteIdGatewayShipmentHistoryResponses, GetApiSiteBySiteIdVoltacallSubscriberDetailsData, GetApiSiteBySiteIdVoltacallSubscriberDetailsErrors, GetApiSiteBySiteIdVoltacallSubscriberDetailsResponses, GetApiSiteBySiteIdVoltacallSubscriberTransferSignatureData, GetApiSiteBySiteIdVoltacallSubscriberTransferSignatureErrors, GetApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponses, GetApiSiteData, GetApiSiteErrors, GetApiSiteResponses, GetApiSupportSiteBySiteIdAbuseData, GetApiSupportSiteBySiteIdAbuseErrors, GetApiSupportSiteBySiteIdAbuseResponses, GetApiSurveySiteBySiteIdInterventionsData, GetApiSurveySiteBySiteIdInterventionsErrors, GetApiSurveySiteBySiteIdInterventionsResponses, GetAppliancesFromCsLinkIdData, GetAppliancesFromCsLinkIdErrors, GetAppliancesFromCsLinkIdResponses, GetAppointmentData, GetAppointmentErrors, GetAppointmentFilteredData, GetAppointmentFilteredResponses, GetAppointmentInfosData, GetAppointmentInfosResponses, GetAppointmentResponses, GetAppointmentStatusData, GetAppointmentStatusErrors, GetAppointmentStatusResponses, GetAppointmentTypesAccordingToSiteEquipmentWithHeatersData, GetAppointmentTypesAccordingToSiteEquipmentWithHeatersResponses, GetAppointmentTypesAccordingToSiteEquipmentWithoutHeatersData, GetAppointmentTypesAccordingToSiteEquipmentWithoutHeatersResponses, GetAutoDiagnosticData, GetAutoDiagnosticErrors, GetAutoDiagnosticResponses, GetCancellationReasonData, GetCancellationReasonResponses, GetDataHistHourlyData, GetDataHistHourlyErrors, GetDataHistHourlyResponses, GetEventFromEventIdData, GetEventFromEventIdErrors, GetEventFromEventIdResponses, GetEventListFromCategoryIdData, GetEventListFromCategoryIdErrors, GetEventListFromCategoryIdResponses, GetFirstInstallationData, GetFirstInstallationErrors, GetFirstInstallationResponses, GetInstallTestResultsByTestIdData, GetInstallTestResultsByTestIdErrors, GetInstallTestResultsByTestIdResponses, GetInstallTestsByModulatorCsIdData, GetInstallTestsByModulatorCsIdErrors, GetInstallTestsByModulatorCsIdResponses, GetInstallTestsByModulatorHwIdData, GetInstallTestsByModulatorHwIdErrors, GetInstallTestsByModulatorHwIdResponses, GetInstallTestsByMomboxHwIdData, GetInstallTestsByMomboxHwIdErrors, GetInstallTestsByMomboxHwIdResponses, GetInstallTestsBySiteIdData, GetInstallTestsBySiteIdErrors, GetInstallTestsBySiteIdResponses, GetLastButtonEventsData, GetLastButtonEventsErrors, GetLastButtonEventsResponses, GetLastEventFromSiteIdAndCategoryIdData, GetLastEventFromSiteIdAndCategoryIdErrors, GetLastEventFromSiteIdAndCategoryIdResponses, GetLastModulatorsTemperatureData, GetLastModulatorsTemperatureErrors, GetLastModulatorsTemperatureResponses, GetLastMomboxGprsInfoData, GetLastMomboxGprsInfoErrors, GetLastMomboxGprsInfoResponses, GetLastMomboxSoftwareUpdateData, GetLastMomboxSoftwareUpdateErrors, GetLastMomboxSoftwareUpdateResponses, GetLastPowerDataData, GetLastPowerDataErrors, GetLastPowerDataResponses, GetLastSiteConfigurationData, GetLastSiteConfigurationErrors, GetLastSiteConfigurationResponses, GetLastSubscriberCommunicationData, GetLastSubscriberCommunicationErrors, GetLastSubscriberCommunicationResponses, GetLegacySubscriberFromSiteIdData, GetLegacySubscriberFromSiteIdErrors, GetLegacySubscriberFromSiteIdResponses, GetLinksFromModulatorHwIdData, GetLinksFromModulatorHwIdErrors, GetLinksFromModulatorHwIdResponses, GetMeData, GetMeErrors, GetMeResponses, GetModulatorAcquisitionRate24hData, GetModulatorAcquisitionRate24hErrors, GetModulatorAcquisitionRate24hResponses, GetModulatorAcquisitionRate30dData, GetModulatorAcquisitionRate30dErrors, GetModulatorAcquisitionRate30dResponses, GetModulatorAcquisitionRate7dData, GetModulatorAcquisitionRate7dErrors, GetModulatorAcquisitionRate7dResponses, GetModulatorData, GetModulatorErrors, GetModulatorLast7DaysWorkingConditionData, GetModulatorLast7DaysWorkingConditionErrors, GetModulatorLast7DaysWorkingConditionResponses, GetModulatorListData, GetModulatorListErrors, GetModulatorListFromMomboxIdData, GetModulatorListFromMomboxIdErrors, GetModulatorListFromMomboxIdResponses, GetModulatorListResponses, GetModulatorResponses, GetMomboxCompositionData, GetMomboxCompositionErrors, GetMomboxCompositionResponses, GetMomboxData, GetMomboxDataInfosData, GetMomboxDataInfosErrors, GetMomboxDataInfosResponses, GetMomboxErrors, GetMomboxLastConnectionData, GetMomboxLastConnectionDateListData, GetMomboxLastConnectionDateListErrors, GetMomboxLastConnectionDateListResponses, GetMomboxLastConnectionErrors, GetMomboxLastConnectionResponses, GetMomboxListData, GetMomboxListErrors, GetMomboxListResponses, GetMomboxResponses, GetNextAvailabilityFromSiteIdData, GetNextAvailabilityFromSiteIdErrors, GetNextAvailabilityFromSiteIdResponses, GetOperatorsPartnerAvailabilitiesData, GetOperatorsPartnerAvailabilitiesResponses, GetPartnersAvailabilitiesData, GetPartnersAvailabilitiesErrors, GetPartnersAvailabilitiesResponses, GetPersonAccessData, GetPersonAccessErrors, GetPersonAccessResponses, GetPhotosListData, GetPhotosListResponses, GetSiteAppointmentPreparationData, GetSiteAppointmentPreparationResponses, GetSiteConstraintsSummaryData, GetSiteConstraintsSummaryErrors, GetSiteConstraintsSummaryResponses, GetSiteNextAppointmentSummaryData, GetSiteNextAppointmentSummaryResponses, GetSiteServiceProviderData, GetSiteServiceProviderResponses, GetSiteV2Data, GetSiteV2Errors, GetSiteV2Responses, GetThirdPartyDetailsFromCsIdData, GetThirdPartyDetailsFromCsIdErrors, GetThirdPartyDetailsFromCsIdResponses, GetTicketsBySiteIdData, GetTicketsBySiteIdErrors, GetTicketsBySiteIdResponses, GetTreeEventsFromSiteIdData, GetTreeEventsFromSiteIdErrors, GetTreeEventsFromSiteIdResponses, HelloData, HelloErrors, HelloResponses, InsertEventData, InsertEventErrors, InsertEventResponses, NewAppointmentData, NewAppointmentErrors, NewAppointmentResponses, PostApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMailData, PostApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMailErrors, PostApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMailResponses, PostApiPhoningSiteBySiteIdEndCallData, PostApiPhoningSiteBySiteIdEndCallErrors, PostApiPhoningSiteBySiteIdEndCallResponses, PostApiSiteBySiteIdGatewayShipmentRequestData, PostApiSiteBySiteIdGatewayShipmentRequestErrors, PostApiSiteBySiteIdGatewayShipmentRequestResponses, PostApiSiteBySiteIdSupportMailData, PostApiSiteBySiteIdSupportMailErrors, PostApiSiteBySiteIdSupportMailResponses, PostApiSiteBySiteIdVoltacallSubscriberTransferSignatureData, PostApiSiteBySiteIdVoltacallSubscriberTransferSignatureErrors, PostApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponses, PostApiSiteSearchData, PostApiSiteSearchErrors, PostApiSiteSearchResponses, PostApiSupportSiteBySiteIdAbuseData, PostApiSupportSiteBySiteIdAbuseErrors, PostApiSupportSiteBySiteIdAbuseResponses, PostApiSurveySiteBySiteIdInstallSatisfactionData, PostApiSurveySiteBySiteIdInstallSatisfactionErrors, PostApiSurveySiteBySiteIdInstallSatisfactionResponses, PostTokenData, PostTokenErrors, PostTokenExternalData, PostTokenExternalErrors, PostTokenExternalResponses, PostTokenResponses, RefreshAllAppliancesOnSiteData, RefreshAllAppliancesOnSiteErrors, RefreshAllAppliancesOnSiteResponses, RenewedPeriodForFlexibleAppointmentData, RenewedPeriodForFlexibleAppointmentErrors, RenewedPeriodForFlexibleAppointmentResponses, ReplaceSiteAddressV2Data, ReplaceSiteAddressV2Errors, ReplaceSiteAddressV2Responses, RequestLinkAutoTestData, RequestLinkAutoTestErrors, RequestLinkAutoTestResponses, RequestVxRexTestsData, RequestVxRexTestsErrors, RequestVxRexTestsResponses, RetrieveVxRexTestsData, RetrieveVxRexTestsErrors, RetrieveVxRexTestsResponses, SendNotificationForSelfAppointmentData, SendNotificationForSelfAppointmentErrors, SendNotificationForSelfAppointmentResponses, UpdateGatewayFromSerialNumberData, UpdateGatewayFromSerialNumberErrors, UpdateGatewayFromSerialNumberResponses, UpdateManualAppointmentData, UpdateManualAppointmentResponses, UpdateSiteAddressV2Data, UpdateSiteAddressV2Errors, UpdateSiteAddressV2Responses, UpdateSiteV2Data, UpdateSiteV2Errors, UpdateSiteV2Responses, UpsertFlexibleAppointmentData, UpsertFlexibleAppointmentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Retrieve a site by id
 */
export const getSiteV2 = <ThrowOnError extends boolean = false>(options: Options<GetSiteV2Data, ThrowOnError>) => (options.client ?? client).get<GetSiteV2Responses, GetSiteV2Errors, ThrowOnError>({ url: '/api/site/v2/{siteId}', ...options });

/**
 * Update a site with a given id
 */
export const updateSiteV2 = <ThrowOnError extends boolean = false>(options: Options<UpdateSiteV2Data, ThrowOnError>) => (options.client ?? client).put<UpdateSiteV2Responses, UpdateSiteV2Errors, ThrowOnError>({
    url: '/api/site/v2/{siteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a site
 */
export const createSiteV2 = <ThrowOnError extends boolean = false>(options: Options<CreateSiteV2Data, ThrowOnError>) => (options.client ?? client).post<CreateSiteV2Responses, CreateSiteV2Errors, ThrowOnError>({
    url: '/api/site/v2',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Partially update a site address V2
 */
export const updateSiteAddressV2 = <ThrowOnError extends boolean = false>(options: Options<UpdateSiteAddressV2Data, ThrowOnError>) => (options.client ?? client).patch<UpdateSiteAddressV2Responses, UpdateSiteAddressV2Errors, ThrowOnError>({
    url: '/api/site/v2/{siteId}/address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fully replace a site address V2
 */
export const replaceSiteAddressV2 = <ThrowOnError extends boolean = false>(options: Options<ReplaceSiteAddressV2Data, ThrowOnError>) => (options.client ?? client).put<ReplaceSiteAddressV2Responses, ReplaceSiteAddressV2Errors, ThrowOnError>({
    url: '/api/site/v2/{siteId}/address',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the site's installation photos
 */
export const getPhotosList = <ThrowOnError extends boolean = false>(options: Options<GetPhotosListData, ThrowOnError>) => (options.client ?? client).get<GetPhotosListResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/photosList', ...options });

/**
 * Download a photo
 */
export const downloadPhoto = <ThrowOnError extends boolean = false>(options: Options<DownloadPhotoData, ThrowOnError>) => (options.client ?? client).get<DownloadPhotoResponses, unknown, ThrowOnError>({ url: '/api/photos/{publicPhotoId}', ...options });

/**
 * Get abuse report from site
 */
export const getApiSupportSiteBySiteIdAbuse = <ThrowOnError extends boolean = false>(options: Options<GetApiSupportSiteBySiteIdAbuseData, ThrowOnError>) => (options.client ?? client).get<GetApiSupportSiteBySiteIdAbuseResponses, GetApiSupportSiteBySiteIdAbuseErrors, ThrowOnError>({ url: '/api/support/site/{siteId}/abuse', ...options });

/**
 * Send abuse report
 */
export const postApiSupportSiteBySiteIdAbuse = <ThrowOnError extends boolean = false>(options: Options<PostApiSupportSiteBySiteIdAbuseData, ThrowOnError>) => (options.client ?? client).post<PostApiSupportSiteBySiteIdAbuseResponses, PostApiSupportSiteBySiteIdAbuseErrors, ThrowOnError>({
    url: '/api/support/site/{siteId}/abuse',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Mail for ask electricity contract
 */
export const postApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMail = <ThrowOnError extends boolean = false>(options: Options<PostApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMailData, ThrowOnError>) => (options.client ?? client).post<PostApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMailResponses, PostApiEmailSiteBySiteIdSubscriberBySubscriberIdSendAskElectricityContractMailErrors, ThrowOnError>({ url: '/api/email/site/{siteId}/subscriber/{subscriberId}/send-ask-electricity-contract-mail', ...options });

/**
 * Get last Date where invalid pdl email was sent
 */
export const getApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmail = <ThrowOnError extends boolean = false>(options: Options<GetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailData, ThrowOnError>) => (options.client ?? client).get<GetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailResponses, GetApiEmailSiteBySiteIdSubscriberBySubscriberIdLastSendingDatetimeForInvalidPdlEmailErrors, ThrowOnError>({ url: '/api/email/site/{siteId}/subscriber/{subscriberId}/last-sending-datetime-for-invalid-pdl-email', ...options });

/**
 * save survey install satisfaction
 */
export const postApiSurveySiteBySiteIdInstallSatisfaction = <ThrowOnError extends boolean = false>(options: Options<PostApiSurveySiteBySiteIdInstallSatisfactionData, ThrowOnError>) => (options.client ?? client).post<PostApiSurveySiteBySiteIdInstallSatisfactionResponses, PostApiSurveySiteBySiteIdInstallSatisfactionErrors, ThrowOnError>({
    url: '/api/survey/site/{siteId}/install-satisfaction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get intervention survey
 */
export const getApiSurveySiteBySiteIdInterventions = <ThrowOnError extends boolean = false>(options: Options<GetApiSurveySiteBySiteIdInterventionsData, ThrowOnError>) => (options.client ?? client).get<GetApiSurveySiteBySiteIdInterventionsResponses, GetApiSurveySiteBySiteIdInterventionsErrors, ThrowOnError>({ url: '/api/survey/site/{siteId}/interventions', ...options });

/**
 * Search a list of sites with parameters
 *
 * Returns sites matching provided filters. At least one filter parameter must be provided.
 */
export const getApiSite = <ThrowOnError extends boolean = false>(options?: Options<GetApiSiteData, ThrowOnError>) => (options?.client ?? client).get<GetApiSiteResponses, GetApiSiteErrors, ThrowOnError>({ url: '/api/site', ...options });

/**
 * Search sites using smart filters
 */
export const postApiSiteSearch = <ThrowOnError extends boolean = false>(options: Options<PostApiSiteSearchData, ThrowOnError>) => (options.client ?? client).post<PostApiSiteSearchResponses, PostApiSiteSearchErrors, ThrowOnError>({
    url: '/api/site/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get subscriber details by siteId
 */
export const getApiSiteBySiteIdVoltacallSubscriberDetails = <ThrowOnError extends boolean = false>(options: Options<GetApiSiteBySiteIdVoltacallSubscriberDetailsData, ThrowOnError>) => (options.client ?? client).get<GetApiSiteBySiteIdVoltacallSubscriberDetailsResponses, GetApiSiteBySiteIdVoltacallSubscriberDetailsErrors, ThrowOnError>({ url: '/api/site/{siteId}/voltacall/subscriber/details', ...options });

/**
 * Cancel ongoing transfer signature
 *
 * Cancels an ongoing transfer signature on YouSign and updates the database
 */
export const deleteApiSiteBySiteIdVoltacallSubscriberTransferSignature = <ThrowOnError extends boolean = false>(options: Options<DeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponses, DeleteApiSiteBySiteIdVoltacallSubscriberTransferSignatureErrors, ThrowOnError>({ url: '/api/site/{siteId}/voltacall/subscriber/transfer-signature', ...options });

/**
 * Get ongoing transfer signature URL
 *
 * Retrieves the YouSign URL for an ongoing transfer signature if one exists
 */
export const getApiSiteBySiteIdVoltacallSubscriberTransferSignature = <ThrowOnError extends boolean = false>(options: Options<GetApiSiteBySiteIdVoltacallSubscriberTransferSignatureData, ThrowOnError>) => (options.client ?? client).get<GetApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponses, GetApiSiteBySiteIdVoltacallSubscriberTransferSignatureErrors, ThrowOnError>({ url: '/api/site/{siteId}/voltacall/subscriber/transfer-signature', ...options });

/**
 * Generate a new transfer signature
 *
 * Creates a new transfer signature and returns the YouSign URL
 */
export const postApiSiteBySiteIdVoltacallSubscriberTransferSignature = <ThrowOnError extends boolean = false>(options: Options<PostApiSiteBySiteIdVoltacallSubscriberTransferSignatureData, ThrowOnError>) => (options.client ?? client).post<PostApiSiteBySiteIdVoltacallSubscriberTransferSignatureResponses, PostApiSiteBySiteIdVoltacallSubscriberTransferSignatureErrors, ThrowOnError>({
    url: '/api/site/{siteId}/voltacall/subscriber/transfer-signature',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search momboxes by serial prefix
 *
 * Returns all momboxes whose serial number starts with the provided serial value.
 */
export const getApiMomboxSerialBySerialSearch = <ThrowOnError extends boolean = false>(options: Options<GetApiMomboxSerialBySerialSearchData, ThrowOnError>) => (options.client ?? client).get<GetApiMomboxSerialBySerialSearchResponses, GetApiMomboxSerialBySerialSearchErrors, ThrowOnError>({ url: '/api/mombox/serial/{serial}/search', ...options });

/**
 * Retrieve available end call reasons
 */
export const getApiPhoningEndCallReasons = <ThrowOnError extends boolean = false>(options?: Options<GetApiPhoningEndCallReasonsData, ThrowOnError>) => (options?.client ?? client).get<GetApiPhoningEndCallReasonsResponses, GetApiPhoningEndCallReasonsErrors, ThrowOnError>({ url: '/api/phoning/end-call/reasons', ...options });

/**
 * List the available gateway shipment reasons
 */
export const getApiGatewayShipmentReasons = <ThrowOnError extends boolean = false>(options?: Options<GetApiGatewayShipmentReasonsData, ThrowOnError>) => (options?.client ?? client).get<GetApiGatewayShipmentReasonsResponses, GetApiGatewayShipmentReasonsErrors, ThrowOnError>({ url: '/api/gateway/shipment/reasons', ...options });

/**
 * List the available gateway model types
 */
export const getApiGatewayShipmentModelTypes = <ThrowOnError extends boolean = false>(options?: Options<GetApiGatewayShipmentModelTypesData, ThrowOnError>) => (options?.client ?? client).get<GetApiGatewayShipmentModelTypesResponses, GetApiGatewayShipmentModelTypesErrors, ThrowOnError>({ url: '/api/gateway/shipment/model-types', ...options });

/**
 * List past gateway shipment requests for a site
 */
export const getApiSiteBySiteIdGatewayShipmentHistory = <ThrowOnError extends boolean = false>(options: Options<GetApiSiteBySiteIdGatewayShipmentHistoryData, ThrowOnError>) => (options.client ?? client).get<GetApiSiteBySiteIdGatewayShipmentHistoryResponses, GetApiSiteBySiteIdGatewayShipmentHistoryErrors, ThrowOnError>({ url: '/api/site/{siteId}/gateway/shipment/history', ...options });

/**
 * Request a gateway shipment for a site
 */
export const postApiSiteBySiteIdGatewayShipmentRequest = <ThrowOnError extends boolean = false>(options: Options<PostApiSiteBySiteIdGatewayShipmentRequestData, ThrowOnError>) => (options.client ?? client).post<PostApiSiteBySiteIdGatewayShipmentRequestResponses, PostApiSiteBySiteIdGatewayShipmentRequestErrors, ThrowOnError>({
    url: '/api/site/{siteId}/gateway/shipment/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End a call for a site
 */
export const postApiPhoningSiteBySiteIdEndCall = <ThrowOnError extends boolean = false>(options: Options<PostApiPhoningSiteBySiteIdEndCallData, ThrowOnError>) => (options.client ?? client).post<PostApiPhoningSiteBySiteIdEndCallResponses, PostApiPhoningSiteBySiteIdEndCallErrors, ThrowOnError>({
    url: '/api/phoning/site/{siteId}/end-call',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the available support types
 *
 * REF_TYPE_SUPPORT referential, offered on the support screen next to the comment and the
 * subscriber support need. The `id` is what `POST /api/site/{siteId}/supportMail` expects as
 * `supportTypeId`.
 *
 */
export const getApiReferenceTypeSupport = <ThrowOnError extends boolean = false>(options?: Options<GetApiReferenceTypeSupportData, ThrowOnError>) => (options?.client ?? client).get<GetApiReferenceTypeSupportResponses, GetApiReferenceTypeSupportErrors, ThrowOnError>({ url: '/api/reference/typeSupport', ...options });

/**
 * List the available subscriber support needs
 *
 * Static referential "1. Demande adhérents" offered on the support screen, next to the
 * support type and the comment. Returned in business order, from "1.1" to "1.6".
 *
 */
export const getApiReferenceSupportSubscriberNeeds = <ThrowOnError extends boolean = false>(options?: Options<GetApiReferenceSupportSubscriberNeedsData, ThrowOnError>) => (options?.client ?? client).get<GetApiReferenceSupportSubscriberNeedsResponses, GetApiReferenceSupportSubscriberNeedsErrors, ThrowOnError>({ url: '/api/reference/support-subscriber-needs', ...options });

/**
 * Create a support ticket for a site
 *
 * Creates a Zendesk ticket from the support type, the advisor comment and, optionally, the
 * selected subscriber support need. When `supportSubscriberNeedCode` is provided, `Problème sur : <label> [<code>]`
 * is prepended as the first line of the ticket description; no structured Zendesk field is set
 * by this endpoint.
 *
 */
export const postApiSiteBySiteIdSupportMail = <ThrowOnError extends boolean = false>(options: Options<PostApiSiteBySiteIdSupportMailData, ThrowOnError>) => (options.client ?? client).post<PostApiSiteBySiteIdSupportMailResponses, PostApiSiteBySiteIdSupportMailErrors, ThrowOnError>({
    url: '/api/site/{siteId}/supportMail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all tickets for a specific site
 *
 * Retrieves all Zendesk tickets associated with the given site ID
 */
export const getTicketsBySiteId = <ThrowOnError extends boolean = false>(options: Options<GetTicketsBySiteIdData, ThrowOnError>) => (options.client ?? client).get<GetTicketsBySiteIdResponses, GetTicketsBySiteIdErrors, ThrowOnError>({ url: '/api/zendesk/site/{siteId}/tickets', ...options });

/**
 * Return filtered appointments
 */
export const getAppointmentFiltered = <ThrowOnError extends boolean = false>(options: Options<GetAppointmentFilteredData, ThrowOnError>) => (options.client ?? client).get<GetAppointmentFilteredResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/appointments', ...options });

/**
 * Return appointment status
 */
export const getAppointmentStatus = <ThrowOnError extends boolean = false>(options: Options<GetAppointmentStatusData, ThrowOnError>) => (options.client ?? client).get<GetAppointmentStatusResponses, GetAppointmentStatusErrors, ThrowOnError>({ url: '/api/appointments/{appointmentId}/status', ...options });

/**
 * Cancel site appointment
 */
export const cancelAppointment = <ThrowOnError extends boolean = false>(options: Options<CancelAppointmentData, ThrowOnError>) => (options.client ?? client).delete<CancelAppointmentResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/appointments/{appointmentId}', ...options });

/**
 * Return filtered appointments
 */
export const getAppointment = <ThrowOnError extends boolean = false>(options: Options<GetAppointmentData, ThrowOnError>) => (options.client ?? client).get<GetAppointmentResponses, GetAppointmentErrors, ThrowOnError>({ url: '/api/site/{siteId}/appointments/{appointmentId}', ...options });

/**
 * Update site appointment
 */
export const updateManualAppointment = <ThrowOnError extends boolean = false>(options: Options<UpdateManualAppointmentData, ThrowOnError>) => (options.client ?? client).put<UpdateManualAppointmentResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/{appointmentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel site appointment
 */
export const cancelAppointmentWithoutSiteId = <ThrowOnError extends boolean = false>(options: Options<CancelAppointmentWithoutSiteIdData, ThrowOnError>) => (options.client ?? client).delete<CancelAppointmentWithoutSiteIdResponses, unknown, ThrowOnError>({ url: '/api/appointments/{appointmentId}', ...options });

/**
 * Set new appointment and close all existing appointment with planned as state
 */
export const newAppointment = <ThrowOnError extends boolean = false>(options: Options<NewAppointmentData, ThrowOnError>) => (options.client ?? client).post<NewAppointmentResponses, NewAppointmentErrors, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/manual',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * cancel site appointment
 */
export const cancelAppointmentPost = <ThrowOnError extends boolean = false>(options: Options<CancelAppointmentPostData, ThrowOnError>) => (options.client ?? client).post<CancelAppointmentPostResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/{appointmentId}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * cancel site appointment
 */
export const cancelAppointmentPostWithoutsiteId = <ThrowOnError extends boolean = false>(options: Options<CancelAppointmentPostWithoutsiteIdData, ThrowOnError>) => (options.client ?? client).post<CancelAppointmentPostWithoutsiteIdResponses, unknown, ThrowOnError>({
    url: '/api/appointments/{appointmentId}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return appointment types by service and site
 */
export const getAppointmentTypesAccordingToSiteEquipmentWithoutHeaters = <ThrowOnError extends boolean = false>(options: Options<GetAppointmentTypesAccordingToSiteEquipmentWithoutHeatersData, ThrowOnError>) => (options.client ?? client).get<GetAppointmentTypesAccordingToSiteEquipmentWithoutHeatersResponses, unknown, ThrowOnError>({ url: '/api/appointments/types/site/{siteId}', ...options });

/**
 * Return appointment types by service and site. Delta correspond to eligible appliances minus installed appliances
 */
export const getAppointmentTypesAccordingToSiteEquipmentWithHeaters = <ThrowOnError extends boolean = false>(options: Options<GetAppointmentTypesAccordingToSiteEquipmentWithHeatersData, ThrowOnError>) => (options.client ?? client).get<GetAppointmentTypesAccordingToSiteEquipmentWithHeatersResponses, unknown, ThrowOnError>({ url: '/api/appointments/types/site/{siteId}/radiators/{delta}', ...options });

/**
 * Return partners' availabilities
 */
export const getPartnersAvailabilities = <ThrowOnError extends boolean = false>(options: Options<GetPartnersAvailabilitiesData, ThrowOnError>) => (options.client ?? client).post<GetPartnersAvailabilitiesResponses, GetPartnersAvailabilitiesErrors, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/partner/availabilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return operator's partner availabilities
 */
export const getOperatorsPartnerAvailabilities = <ThrowOnError extends boolean = false>(options: Options<GetOperatorsPartnerAvailabilitiesData, ThrowOnError>) => (options.client ?? client).post<GetOperatorsPartnerAvailabilitiesResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/operator/partner/availabilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creating appointment reservation in external services
 */
export const createPartnerAppointment = <ThrowOnError extends boolean = false>(options: Options<CreatePartnerAppointmentData, ThrowOnError>) => (options.client ?? client).post<CreatePartnerAppointmentResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/partner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creating forced appointment reservation in external services
 */
export const createForcedPartnerAppointment = <ThrowOnError extends boolean = false>(options: Options<CreateForcedPartnerAppointmentData, ThrowOnError>) => (options.client ?? client).post<CreateForcedPartnerAppointmentResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/partner/fixed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Return appointment preparation for site
 */
export const getSiteAppointmentPreparation = <ThrowOnError extends boolean = false>(options: Options<GetSiteAppointmentPreparationData, ThrowOnError>) => (options.client ?? client).get<GetSiteAppointmentPreparationResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/appointments/preparation', ...options });

/**
 * Set appointment preparation for site
 */
export const createSiteAppointmentPreparation = <ThrowOnError extends boolean = false>(options: Options<CreateSiteAppointmentPreparationData, ThrowOnError>) => (options.client ?? client).post<CreateSiteAppointmentPreparationResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/preparation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get number of flexible appointment and flexible appointments close deadline
 */
export const countFlexAppointmentAndCountAppointmentCloseDeadLine = <ThrowOnError extends boolean = false>(options?: Options<CountFlexAppointmentAndCountAppointmentCloseDeadLineData, ThrowOnError>) => (options?.client ?? client).get<CountFlexAppointmentAndCountAppointmentCloseDeadLineResponses, unknown, ThrowOnError>({ url: '/api/appointment/flexible/count', ...options });

/**
 * Creating flexible appointment
 */
export const createFlexibleAppointment = <ThrowOnError extends boolean = false>(options: Options<CreateFlexibleAppointmentData, ThrowOnError>) => (options.client ?? client).post<CreateFlexibleAppointmentResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/flexible',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creating flexible appointment
 */
export const upsertFlexibleAppointment = <ThrowOnError extends boolean = false>(options: Options<UpsertFlexibleAppointmentData, ThrowOnError>) => (options.client ?? client).put<UpsertFlexibleAppointmentResponses, unknown, ThrowOnError>({
    url: '/api/site/{siteId}/appointments/flexible',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reinitialize period for flex appointment
 */
export const renewedPeriodForFlexibleAppointment = <ThrowOnError extends boolean = false>(options: Options<RenewedPeriodForFlexibleAppointmentData, ThrowOnError>) => (options.client ?? client).post<RenewedPeriodForFlexibleAppointmentResponses, RenewedPeriodForFlexibleAppointmentErrors, ThrowOnError>({
    url: '/api/site/{siteId}/appointment/flexible/renewed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Getting cancellation reason
 */
export const getCancellationReason = <ThrowOnError extends boolean = false>(options: Options<GetCancellationReasonData, ThrowOnError>) => (options.client ?? client).get<GetCancellationReasonResponses, unknown, ThrowOnError>({ url: '/api/site/appointments/reason/{cancellationReasonTypeId}', ...options });

/**
 * Return next appointment summary for site
 */
export const getSiteNextAppointmentSummary = <ThrowOnError extends boolean = false>(options: Options<GetSiteNextAppointmentSummaryData, ThrowOnError>) => (options.client ?? client).get<GetSiteNextAppointmentSummaryResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/appointments/next-appointment', ...options });

/**
 * Declare the technician on way to the associated site
 */
export const declareTechnicianOnWayToSite = <ThrowOnError extends boolean = false>(options: Options<DeclareTechnicianOnWayToSiteData, ThrowOnError>) => (options.client ?? client).put<DeclareTechnicianOnWayToSiteResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/appointments/{appointmentId}/declare-technician-on-way', ...options });

/**
 * Cancel the declaration of technician on way to the associated site
 */
export const cancelTechnicianOnWayToSite = <ThrowOnError extends boolean = false>(options: Options<CancelTechnicianOnWayToSiteData, ThrowOnError>) => (options.client ?? client).delete<CancelTechnicianOnWayToSiteResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/appointments/{appointmentId}/cancel-technician-on-way', ...options });

/**
 * Getting appointment infos for update
 */
export const getAppointmentInfos = <ThrowOnError extends boolean = false>(options: Options<GetAppointmentInfosData, ThrowOnError>) => (options.client ?? client).get<GetAppointmentInfosResponses, unknown, ThrowOnError>({ url: '/api/site/appointments/infos/{appointmentId}', ...options });

/**
 * Confirm that an appointment has been made with the subscriber.
 */
export const confirmAppointment = <ThrowOnError extends boolean = false>(options: Options<ConfirmAppointmentData, ThrowOnError>) => (options.client ?? client).post<ConfirmAppointmentResponses, unknown, ThrowOnError>({ url: '/api/appointment/{appointmentId}/confirm', ...options });

/**
 * Get intervention service providers from site id
 */
export const getSiteServiceProvider = <ThrowOnError extends boolean = false>(options: Options<GetSiteServiceProviderData, ThrowOnError>) => (options.client ?? client).get<GetSiteServiceProviderResponses, unknown, ThrowOnError>({ url: '/api/site/{siteId}/service-providers', ...options });

/**
 * Send link by sms and/or mail to subscriber for self booked appointment
 */
export const sendNotificationForSelfAppointment = <ThrowOnError extends boolean = false>(options: Options<SendNotificationForSelfAppointmentData, ThrowOnError>) => (options.client ?? client).post<SendNotificationForSelfAppointmentResponses, SendNotificationForSelfAppointmentErrors, ThrowOnError>({
    url: '/api/site/{siteId}/self-appointment-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 */
export const postToken = <ThrowOnError extends boolean = false>(options: Options<PostTokenData, ThrowOnError>) => (options.client ?? client).post<PostTokenResponses, PostTokenErrors, ThrowOnError>({
    url: '/login/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a subscriber from a site id
 *
 * Returns the legacy subscriber model attached to the given site.
 */
export const getLegacySubscriberFromSiteId = <ThrowOnError extends boolean = false>(options: Options<GetLegacySubscriberFromSiteIdData, ThrowOnError>) => (options.client ?? client).get<GetLegacySubscriberFromSiteIdResponses, GetLegacySubscriberFromSiteIdErrors, ThrowOnError>({ url: '/api/site/{siteId}/subscriber', ...options });

/**
 * List installation tests for a site
 */
export const getInstallTestsBySiteId = <ThrowOnError extends boolean = false>(options: Options<GetInstallTestsBySiteIdData, ThrowOnError>) => (options.client ?? client).get<GetInstallTestsBySiteIdResponses, GetInstallTestsBySiteIdErrors, ThrowOnError>({ url: '/api/site/{siteId}/installtests', ...options });

/**
 * List installation tests for a mombox
 */
export const getInstallTestsByMomboxHwId = <ThrowOnError extends boolean = false>(options: Options<GetInstallTestsByMomboxHwIdData, ThrowOnError>) => (options.client ?? client).get<GetInstallTestsByMomboxHwIdResponses, GetInstallTestsByMomboxHwIdErrors, ThrowOnError>({ url: '/api/mombox/{momboxHwId}/installtests', ...options });

/**
 * List installation tests for a modulator hardware ID
 */
export const getInstallTestsByModulatorHwId = <ThrowOnError extends boolean = false>(options: Options<GetInstallTestsByModulatorHwIdData, ThrowOnError>) => (options.client ?? client).get<GetInstallTestsByModulatorHwIdResponses, GetInstallTestsByModulatorHwIdErrors, ThrowOnError>({ url: '/api/modulator/{modulatorHwId}/installtests', ...options });

/**
 * List installation tests for a modulator configuration ID
 */
export const getInstallTestsByModulatorCsId = <ThrowOnError extends boolean = false>(options: Options<GetInstallTestsByModulatorCsIdData, ThrowOnError>) => (options.client ?? client).get<GetInstallTestsByModulatorCsIdResponses, GetInstallTestsByModulatorCsIdErrors, ThrowOnError>({ url: '/api/modulator/cs/{modulatorCsId}/installtests', ...options });

/**
 * List the results of an installation test
 *
 * Returns no response body when the installation test does not exist.
 */
export const getInstallTestResultsByTestId = <ThrowOnError extends boolean = false>(options: Options<GetInstallTestResultsByTestIdData, ThrowOnError>) => (options.client ?? client).get<GetInstallTestResultsByTestIdResponses, GetInstallTestResultsByTestIdErrors, ThrowOnError>({ url: '/api/installtest/{installTestId}/results', ...options });

/**
 * Get a site's constraint summary
 */
export const getSiteConstraintsSummary = <ThrowOnError extends boolean = false>(options: Options<GetSiteConstraintsSummaryData, ThrowOnError>) => (options.client ?? client).get<GetSiteConstraintsSummaryResponses, GetSiteConstraintsSummaryErrors, ThrowOnError>({ url: '/api/site/{siteId}/constraints-summary', ...options });

/**
 * List the site's latest mombox button events
 */
export const getLastButtonEvents = <ThrowOnError extends boolean = false>(options: Options<GetLastButtonEventsData, ThrowOnError>) => (options.client ?? client).get<GetLastButtonEventsResponses, GetLastButtonEventsErrors, ThrowOnError>({ url: '/api/site/{siteId}/last-button-event', ...options });

/**
 * List the current person's permissions
 */
export const getPersonAccess = <ThrowOnError extends boolean = false>(options?: Options<GetPersonAccessData, ThrowOnError>) => (options?.client ?? client).get<GetPersonAccessResponses, GetPersonAccessErrors, ThrowOnError>({ url: '/api/access', ...options });

/**
 * Get the automatic diagnostic for a site
 */
export const getAutoDiagnostic = <ThrowOnError extends boolean = false>(options: Options<GetAutoDiagnosticData, ThrowOnError>) => (options.client ?? client).get<GetAutoDiagnosticResponses, GetAutoDiagnosticErrors, ThrowOnError>({ url: '/api/autodiag/site/{siteId}', ...options });

/**
 * Request an automatic diagnostic for a link
 */
export const requestLinkAutoTest = <ThrowOnError extends boolean = false>(options: Options<RequestLinkAutoTestData, ThrowOnError>) => (options.client ?? client).put<RequestLinkAutoTestResponses, RequestLinkAutoTestErrors, ThrowOnError>({ url: '/api/autodiag/site/{siteId}/test/link/{csLinkId}', ...options });

/**
 * List appliances attached to a link
 */
export const getAppliancesFromCsLinkId = <ThrowOnError extends boolean = false>(options: Options<GetAppliancesFromCsLinkIdData, ThrowOnError>) => (options.client ?? client).get<GetAppliancesFromCsLinkIdResponses, GetAppliancesFromCsLinkIdErrors, ThrowOnError>({ url: '/api/link/{linkCsId}/appliances', ...options });

/**
 * List links attached to a modulator
 */
export const getLinksFromModulatorHwId = <ThrowOnError extends boolean = false>(options: Options<GetLinksFromModulatorHwIdData, ThrowOnError>) => (options.client ?? client).get<GetLinksFromModulatorHwIdResponses, GetLinksFromModulatorHwIdErrors, ThrowOnError>({ url: '/api/modulator/{modulatorHwId}/links', ...options });

/**
 * Get a mombox by hardware ID
 */
export const getMombox = <ThrowOnError extends boolean = false>(options: Options<GetMomboxData, ThrowOnError>) => (options.client ?? client).get<GetMomboxResponses, GetMomboxErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}', ...options });

/**
 * List a mombox's hardware components
 */
export const getMomboxComposition = <ThrowOnError extends boolean = false>(options: Options<GetMomboxCompositionData, ThrowOnError>) => (options.client ?? client).get<GetMomboxCompositionResponses, GetMomboxCompositionErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}/components', ...options });

/**
 * List a mombox's data frames
 */
export const getMomboxDataInfos = <ThrowOnError extends boolean = false>(options: Options<GetMomboxDataInfosData, ThrowOnError>) => (options.client ?? client).get<GetMomboxDataInfosResponses, GetMomboxDataInfosErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}/dataInfos', ...options });

/**
 * Get the latest GPRS consumption information
 */
export const getLastMomboxGprsInfo = <ThrowOnError extends boolean = false>(options: Options<GetLastMomboxGprsInfoData, ThrowOnError>) => (options.client ?? client).get<GetLastMomboxGprsInfoResponses, GetLastMomboxGprsInfoErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}/gprs-conso', ...options });

/**
 * Get a mombox's latest connection
 */
export const getMomboxLastConnection = <ThrowOnError extends boolean = false>(options: Options<GetMomboxLastConnectionData, ThrowOnError>) => (options.client ?? client).get<GetMomboxLastConnectionResponses, GetMomboxLastConnectionErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}/last-connection', ...options });

/**
 * Get a mombox's latest software update
 */
export const getLastMomboxSoftwareUpdate = <ThrowOnError extends boolean = false>(options: Options<GetLastMomboxSoftwareUpdateData, ThrowOnError>) => (options.client ?? client).get<GetLastMomboxSoftwareUpdateResponses, GetLastMomboxSoftwareUpdateErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}/last-software-update', ...options });

/**
 * List a site's momboxes
 */
export const getMomboxList = <ThrowOnError extends boolean = false>(options: Options<GetMomboxListData, ThrowOnError>) => (options.client ?? client).get<GetMomboxListResponses, GetMomboxListErrors, ThrowOnError>({ url: '/api/site/{siteId}/mombox', ...options });

/**
 * List latest mombox connection dates for a site
 */
export const getMomboxLastConnectionDateList = <ThrowOnError extends boolean = false>(options: Options<GetMomboxLastConnectionDateListData, ThrowOnError>) => (options.client ?? client).get<GetMomboxLastConnectionDateListResponses, GetMomboxLastConnectionDateListErrors, ThrowOnError>({ url: '/api/site/{siteId}/mombox-last-connection-date', ...options });

/**
 * Get the latest communication point for modulators
 */
export const getLastModulatorsTemperature = <ThrowOnError extends boolean = false>(options: Options<GetLastModulatorsTemperatureData, ThrowOnError>) => (options.client ?? client).get<GetLastModulatorsTemperatureResponses, GetLastModulatorsTemperatureErrors, ThrowOnError>({ url: '/api/modulator/last-temperature-point', ...options });

/**
 * Get a modulator's hourly consumption history
 *
 * @deprecated
 */
export const getDataHistHourly = <ThrowOnError extends boolean = false>(options: Options<GetDataHistHourlyData, ThrowOnError>) => (options.client ?? client).get<GetDataHistHourlyResponses, GetDataHistHourlyErrors, ThrowOnError>({ url: '/api/modulator/{modulatorCsId}/consumption', ...options });

/**
 * Get a modulator's latest power point
 *
 * @deprecated
 */
export const getLastPowerData = <ThrowOnError extends boolean = false>(options: Options<GetLastPowerDataData, ThrowOnError>) => (options.client ?? client).get<GetLastPowerDataResponses, GetLastPowerDataErrors, ThrowOnError>({ url: '/api/modulator/{modulatorCsId}/last-point', ...options });

/**
 * Get a modulator by hardware ID
 */
export const getModulator = <ThrowOnError extends boolean = false>(options: Options<GetModulatorData, ThrowOnError>) => (options.client ?? client).get<GetModulatorResponses, GetModulatorErrors, ThrowOnError>({ url: '/api/modulator/{modulatorHwId}', ...options });

/**
 * Get a modulator's acquisition rate over 24 hours
 */
export const getModulatorAcquisitionRate24H = <ThrowOnError extends boolean = false>(options: Options<GetModulatorAcquisitionRate24hData, ThrowOnError>) => (options.client ?? client).get<GetModulatorAcquisitionRate24hResponses, GetModulatorAcquisitionRate24hErrors, ThrowOnError>({ url: '/api/modulator/{modulatorHwId}/acq-rate-24h', ...options });

/**
 * Get a modulator's acquisition rate over 7 days
 */
export const getModulatorAcquisitionRate7D = <ThrowOnError extends boolean = false>(options: Options<GetModulatorAcquisitionRate7dData, ThrowOnError>) => (options.client ?? client).get<GetModulatorAcquisitionRate7dResponses, GetModulatorAcquisitionRate7dErrors, ThrowOnError>({ url: '/api/modulator/{modulatorHwId}/acq-rate-7d', ...options });

/**
 * Get a modulator's acquisition rate over 30 days
 */
export const getModulatorAcquisitionRate30D = <ThrowOnError extends boolean = false>(options: Options<GetModulatorAcquisitionRate30dData, ThrowOnError>) => (options.client ?? client).get<GetModulatorAcquisitionRate30dResponses, GetModulatorAcquisitionRate30dErrors, ThrowOnError>({ url: '/api/modulator/{modulatorHwId}/acq-rate-30d', ...options });

/**
 * List modulators attached to a mombox
 */
export const getModulatorListFromMomboxId = <ThrowOnError extends boolean = false>(options: Options<GetModulatorListFromMomboxIdData, ThrowOnError>) => (options.client ?? client).get<GetModulatorListFromMomboxIdResponses, GetModulatorListFromMomboxIdErrors, ThrowOnError>({ url: '/api/mombox/{pilotHwId}/modulators', ...options });

/**
 * Get the site's modulator working conditions over 7 days
 */
export const getModulatorLast7DaysWorkingCondition = <ThrowOnError extends boolean = false>(options: Options<GetModulatorLast7DaysWorkingConditionData, ThrowOnError>) => (options.client ?? client).get<GetModulatorLast7DaysWorkingConditionResponses, GetModulatorLast7DaysWorkingConditionErrors, ThrowOnError>({ url: '/api/site/{siteId}/modulator/working-condition', ...options });

/**
 * List a site's modulators
 */
export const getModulatorList = <ThrowOnError extends boolean = false>(options: Options<GetModulatorListData, ThrowOnError>) => (options.client ?? client).get<GetModulatorListResponses, GetModulatorListErrors, ThrowOnError>({ url: '/api/site/{siteId}/modulators', ...options });

/**
 * Get the site's latest event in a category
 */
export const getLastEventFromSiteIdAndCategoryId = <ThrowOnError extends boolean = false>(options: Options<GetLastEventFromSiteIdAndCategoryIdData, ThrowOnError>) => (options.client ?? client).get<GetLastEventFromSiteIdAndCategoryIdResponses, GetLastEventFromSiteIdAndCategoryIdErrors, ThrowOnError>({ url: '/api/site/{siteId}/event-category/{eventCategoryId}', ...options });

/**
 * Get the site's latest subscriber communication event
 */
export const getLastSubscriberCommunication = <ThrowOnError extends boolean = false>(options: Options<GetLastSubscriberCommunicationData, ThrowOnError>) => (options.client ?? client).get<GetLastSubscriberCommunicationResponses, GetLastSubscriberCommunicationErrors, ThrowOnError>({ url: '/api/site/{siteId}/event/last-communication', ...options });

/**
 * Get the site's latest hardware configuration event
 */
export const getLastSiteConfiguration = <ThrowOnError extends boolean = false>(options: Options<GetLastSiteConfigurationData, ThrowOnError>) => (options.client ?? client).get<GetLastSiteConfigurationResponses, GetLastSiteConfigurationErrors, ThrowOnError>({ url: '/api/site/{siteId}/event/last-hardware-configuration', ...options });

/**
 * Get the site's first installation event
 */
export const getFirstInstallation = <ThrowOnError extends boolean = false>(options: Options<GetFirstInstallationData, ThrowOnError>) => (options.client ?? client).get<GetFirstInstallationResponses, GetFirstInstallationErrors, ThrowOnError>({ url: '/api/site/{siteId}/event/first-installation', ...options });

/**
 * List events in a category
 */
export const getEventListFromCategoryId = <ThrowOnError extends boolean = false>(options: Options<GetEventListFromCategoryIdData, ThrowOnError>) => (options.client ?? client).get<GetEventListFromCategoryIdResponses, GetEventListFromCategoryIdErrors, ThrowOnError>({ url: '/api/event-category/{categoryId}/events', ...options });

/**
 * Get an event by ID
 */
export const getEventFromEventId = <ThrowOnError extends boolean = false>(options: Options<GetEventFromEventIdData, ThrowOnError>) => (options.client ?? client).get<GetEventFromEventIdResponses, GetEventFromEventIdErrors, ThrowOnError>({ url: '/api/event/{id}', ...options });

/**
 * Create an event
 */
export const insertEvent = <ThrowOnError extends boolean = false>(options: Options<InsertEventData, ThrowOnError>) => (options.client ?? client).post<InsertEventResponses, InsertEventErrors, ThrowOnError>({
    url: '/api/event',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a link between two events
 */
export const createLinkBetweenTwoEvents = <ThrowOnError extends boolean = false>(options: Options<CreateLinkBetweenTwoEventsData, ThrowOnError>) => (options.client ?? client).post<CreateLinkBetweenTwoEventsResponses, CreateLinkBetweenTwoEventsErrors, ThrowOnError>({
    url: '/api/event/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the site's event tree
 */
export const getTreeEventsFromSiteId = <ThrowOnError extends boolean = false>(options: Options<GetTreeEventsFromSiteIdData, ThrowOnError>) => (options.client ?? client).get<GetTreeEventsFromSiteIdResponses, GetTreeEventsFromSiteIdErrors, ThrowOnError>({ url: '/api/site/{siteId}/events/tree', ...options });

/**
 * Check that the authenticated API is reachable
 */
export const hello = <ThrowOnError extends boolean = false>(options?: Options<HelloData, ThrowOnError>) => (options?.client ?? client).get<HelloResponses, HelloErrors, ThrowOnError>({ url: '/api/hello', ...options });

/**
 * Authenticate an external client
 *
 * This endpoint is protected by CAPTCHA validation. The internal /login/token endpoint is documented by internal_auth.yaml.
 */
export const postTokenExternal = <ThrowOnError extends boolean = false>(options: Options<PostTokenExternalData, ThrowOnError>) => (options.client ?? client).post<PostTokenExternalResponses, PostTokenExternalErrors, ThrowOnError>({
    url: '/external/login/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a site's next modulation availability
 */
export const getNextAvailabilityFromSiteId = <ThrowOnError extends boolean = false>(options: Options<GetNextAvailabilityFromSiteIdData, ThrowOnError>) => (options.client ?? client).get<GetNextAvailabilityFromSiteIdResponses, GetNextAvailabilityFromSiteIdErrors, ThrowOnError>({ url: '/api/modulation/site/{siteId}/next-availability', ...options });

/**
 * Refresh the MyV programming of every appliance on a site
 */
export const refreshAllAppliancesOnSite = <ThrowOnError extends boolean = false>(options: Options<RefreshAllAppliancesOnSiteData, ThrowOnError>) => (options.client ?? client).put<RefreshAllAppliancesOnSiteResponses, RefreshAllAppliancesOnSiteErrors, ThrowOnError>({ url: '/api/myv/programming/site/{siteId}/refreshAllAppliances', ...options });

/**
 * Get the current operator
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({ url: '/api/operator/me', ...options });

/**
 * Get a third-party sensor by configuration ID
 */
export const getThirdPartyDetailsFromCsId = <ThrowOnError extends boolean = false>(options: Options<GetThirdPartyDetailsFromCsIdData, ThrowOnError>) => (options.client ?? client).get<GetThirdPartyDetailsFromCsIdResponses, GetThirdPartyDetailsFromCsIdErrors, ThrowOnError>({ url: '/api/third-party/cs/{thirdPartySensorCsId}', ...options });

/**
 * Remove an appliance override association from a third-party sensor
 */
export const deleteThirdPartySensorApplianceAssociation = <ThrowOnError extends boolean = false>(options: Options<DeleteThirdPartySensorApplianceAssociationData, ThrowOnError>) => (options.client ?? client).delete<DeleteThirdPartySensorApplianceAssociationResponses, DeleteThirdPartySensorApplianceAssociationErrors, ThrowOnError>({ url: '/api/third-party/sensor/{thirdPartySensorCsId}/appliance/{applianceCsId}', ...options });

/**
 * Request a software update for a site's gateway
 */
export const updateGatewayFromSerialNumber = <ThrowOnError extends boolean = false>(options: Options<UpdateGatewayFromSerialNumberData, ThrowOnError>) => (options.client ?? client).put<UpdateGatewayFromSerialNumberResponses, UpdateGatewayFromSerialNumberErrors, ThrowOnError>({ url: '/api/vx/device/site/{siteId}/gateway/{serialNumber}/update', ...options });

/**
 * Retrieve VX REX tests for a site
 *
 * @deprecated
 */
export const retrieveVxRexTests = <ThrowOnError extends boolean = false>(options: Options<RetrieveVxRexTestsData, ThrowOnError>) => (options.client ?? client).get<RetrieveVxRexTestsResponses, RetrieveVxRexTestsErrors, ThrowOnError>({ url: '/api/vx/testing/site/{siteId}', ...options });

/**
 * Request VX SmartSwitch tests for a site
 */
export const requestVxRexTests = <ThrowOnError extends boolean = false>(options: Options<RequestVxRexTestsData, ThrowOnError>) => (options.client ?? client).post<RequestVxRexTestsResponses, RequestVxRexTestsErrors, ThrowOnError>({
    url: '/api/vx/testing/site/{siteId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
